import React from 'react';
import { SearchPatientField } from '@/components/search';
import { BoltIcon, EnvelopeIcon, MagnifierIcon, MicrophoneIcon } from './icons';
import {
  ActionButtonContainer,
  CreatePendingPatientContextButton,
  HeaderIconButton,
  OpenZoomButton,
  SpaceBetweenWrapper
} from './common';

export const DashboardContextActions = ({
  isUsapHospital
}: {
  isUsapHospital?: boolean;
}) => (
  <SpaceBetweenWrapper>
    <SearchPatientField />
    {isUsapHospital === false && (
      <ActionButtonContainer>
        <HeaderIconButton disabled icon={<BoltIcon />} />
        <HeaderIconButton disabled icon={<MagnifierIcon />} />
        {/*<HeaderIconButton disabled icon={<BookmarkIcon />} />*/}
        {/*<HeaderIconButton disabled icon={<FireIcon />} />*/}
        <OpenZoomButton />
        {/*<HeaderIconButton disabled icon={<ChatIcon />} />*/}
        <HeaderIconButton disabled icon={<MicrophoneIcon />} />
        <HeaderIconButton disabled icon={<EnvelopeIcon />} />
        <CreatePendingPatientContextButton />
      </ActionButtonContainer>
    )}
  </SpaceBetweenWrapper>
);
